<script setup lang="ts">
  import { computed, ref, watch, onMounted } from 'vue'
  import translaters from '../../tradutors/assine'
  import translateModel from '../../tradutors/model'  
  import { localeStore } from '../../stores/locale'
  import { userStore } from '../../stores/user'
  import { jwtStore } from '../../stores/jwt'
  import { planStore } from '../../stores/plans'  
  import router from '../../router'
  import api from '../../api'
  import { isMobile } from '../../views/shared/utils/mobile'
  import { event } from 'vue-gtag'
  import AssinePlansChoice from 'components/Assine/AssinePlansChoice.vue'
  import LoginSocialMedia from 'components/LoginSocialMedia.vue'
  import ModalSubscribePlans from 'components/Modais/ModalSubscribePlansAndCredits.vue'

  const storeLocale = localeStore()
  const storeUser = userStore()
  const storeJwt = jwtStore()
  const storePlan = planStore()

  const isLoggedIn = computed(() => storeUser.isLoggedIn)
  const dataUser = computed(() => storeUser.user)

  const emit = defineEmits(['showModalMessages'])
  const form = ref({
    firstName: null,
    lastName: null,
    email: null,
    emailAgain: null,
    anotherEmail: null,
    country: null,
    password: null,
    passwordAgain: null,
    acept: true
  })
  const password = ref(null)
  const passwordAgain = ref(null)
  const loading = ref(false)
  const countries = ref(['Brasil', 'Portugal', 'EUA', 'Mexico'])
  const showSubscribe = ref(false)

  const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref

  const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
  })

  const translateModels = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translateModel.portugues
    } else {
      return translateModel.ingles
    }
  })


  watch(reactiveLocale, () => {
    getPaises()
  })

  onMounted(() => {
    getPaises()
  })

  function hidePassword() {
    let input = password.value
    input.type == 'text' ? (input.type = 'password') : (input.type = 'text')
  }

  function hidePasswordAgain() {
    let input = passwordAgain.value
    input.type == 'text' ? (input.type = 'password') : (input.type = 'text')
  }

  function getPaises() {
    api
      .get('v1/subscribe/getPaises?locale=' + reactiveLocale.value)
      .then(({ data }) => {
        countries.value = data
      })
      .catch((error) => console.log(error))
  }
  interface formCheckInterce {
    firstName: string
    lastName: string
    email: string
    emailAgain: string
    anotherEmail: string
    country: string
    password: string
    passwordAgain: string
  }
  function checkForm(formCheck: formCheckInterce) {
    if (!formCheck.firstName) {
      error(reactiveLocale.value == 'pt-br' ? 'Nome é obrigatório!' : 'Name is riquered!')
      return false
    }
    if (!formCheck.lastName) {
      error(reactiveLocale.value == 'pt-br' ? 'Sobrenome é obrigatório!' : 'Lastname is riquered!')
      return false
    }
    if (!formCheck.email) {
      error(reactiveLocale.value == 'pt-br' ? 'Email é obrigatório!' : 'Email is riquered!')
      return false
    }
    if (!formCheck.emailAgain) {
      error(
        reactiveLocale.value == 'pt-br'
          ? 'Confirmação de email é obrigatório!'
          : 'Email confirmation is riquered!'
      )
      return false
    }
    if (formCheck.anotherEmail && formCheck.anotherEmail == formCheck.email) {
      error(
        reactiveLocale.value == 'pt-br'
          ? 'Email alternativo deve ser diferente do email principal!'
          : 'Alternate email must be different from the primary email!'
      )
      return false
    }
    if (!formCheck.country) {
      error(reactiveLocale.value == 'pt-br' ? 'País é obrigatório!' : 'Country is riquered!')
      return false
    }
    if (!formCheck.password) {
      error(reactiveLocale.value == 'pt-br' ? 'Senha é obrigatório!' : 'Password is riquered!')
      return false
    }
    if (!formCheck.passwordAgain) {
      error(
        reactiveLocale.value == 'pt-br'
          ? 'Confirmação de senha é obrigatório!'
          : 'Password confirmation is riquered!'
      )
      return false
    }
    if (
      formCheck.password &&
      formCheck.passwordAgain &&
      formCheck.password != formCheck.passwordAgain
    ) {
      error(reactiveLocale.value == 'pt-br' ? 'Senhas não conferem!' : 'Passwords do not match!')
      return false
    }
    return true
  }

  function error(value) {
    emit('showModalMessages', {
      message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
    })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'erro',
      erro: {
        tipo: value
      }
    })
  }

  function saveAccount() {
    loading.value = true
    if (isLoggedIn.value) {
      redirect('AssinePaymentPage')
    }
    event('checkout2', { method: 'Boleto' })
    if (checkForm(form.value)) {
      api
        .post('v1/subscribe/storeCreateUserAssine', form.value)
        .then(({ data }) => {
          if (!data.process) {
            error(data.errors)
          }
          if (data.login) {
            storeUser.setUser(data.login.user)
            storeJwt.setJwt(data.login.jwt)
            redirect('AssinePaymentPage')
          }
        })
        .catch(
          ({
            response: {
              data: { errors }
            }
          }) => error(errors)
        )
        .finally(() => (loading.value = false))
    } else {
      loading.value = false
    }
  }

  function redirect(name) {
    router.push({
      name,
      params: {
        locale: reactiveLocale.value
      }
    })
  }

  function returnMessage(value){
    error(value)
  }

  function showModalSubscribePlans(val) {
    showSubscribe.value = val
  }

</script>

<template>
  <div class="row pb-3">
    <div class="col-lg-8 col-12 order-2 order-lg-1">
      <div class="col-12 pt-5 pb-2" v-if="isMobile()">
        <div class="resume-title">{{ translate.titleForm }}</div>
        <div class="resume-line"></div>
      </div>
      <div class="form-fields" v-if="!isLoggedIn">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="firstName"
                ref="firstName"
                :placeholder="translate.formUser.firstName"
                v-model="form.firstName"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <input
                ref="lastName"
                type="text"
                class="form-control"
                name="lastName"
                id="lastName"
                :placeholder="translate.formUser.lastName"
                v-model="form.lastName"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <input
                ref="email"
                type="email"
                class="form-control"
                v-model="form.email"
                name="email"
                id="email"
                :placeholder="translate.formUser.email"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <input
                ref="emailAgain"
                type="email"
                class="form-control"
                v-model="form.emailAgain"
                name="emailAgain"
                id="emailAgain"
                :placeholder="translate.formUser.emailAgain"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <input
                ref="anotherEmail"
                type="email"
                class="form-control"
                v-model="form.anotherEmail"
                name="anotherEmail"
                id="anotherEmail"
                :placeholder="translate.formUser.anotherEmail"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <select
                ref="country"
                class="select-box form-control"
                v-model="form.country"
                name="country"
                id="country"
              >
                <option :value="null" disabled>{{ translate.formUser.country }}</option>
                <option v-for="(country, value) in countries" :value="value" :key="value">
                  {{ country }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div class="d-flex flex-nowrap">
                <input
                  ref="password"
                  type="password"
                  class="form-control"
                  v-model="form.password"
                  name="password"
                  id="password"
                  :placeholder="translate.formUser.password"
                />
                <i @click="hidePassword()" class="icon-eye"></i>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <div class="d-flex flex-nowrap">
                <input
                  ref="passwordAgain"
                  type="password"
                  class="form-control"
                  v-model="form.passwordAgain"
                  name="passwordAgain"
                  id="passwordAgain"
                  :placeholder="translate.formUser.passwordAgain"
                />
                <i @click="hidePasswordAgain()" class="icon-eye"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="d-flex justify-content-center pt-4 resume-title">
        {{ reactiveLocale == 'pt-br' ? 'Olá, ' : 'Hi, ' }} {{ dataUser.name }}
        {{ dataUser.last_name }}
      </div>
      <div class="row">
        <div class="text-center mt-3" v-if="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else class="d-flex align-items-center justify-content-center">
          <button type="button" class="plan-button col-lg-3 col-8" @click="saveAccount()">
            {{ translate.buttomPay }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-12 order-1 order-lg-2 resume">
      <AssinePlansChoice />
    </div>
  </div>
  <div class="row" v-if="!isLoggedIn">
    <div class="col-lg-8 col-12 text-login">
      {{ translate.holderSocio }}
    </div>
    <div class="col-lg-8 col-12 mb-5 text-login">
        <button type="button" class="plan-button-login col-lg-3 col-8" @click="showModalSubscribePlans(true)">
          {{ translate.holderLogin }}
        </button>
    </div>
  </div>  
  <div class="row" v-if="!isLoggedIn">
    <div class="col-lg-8 col-12 p-left">
      <LoginSocialMedia redirect="AssinePaymentPage" size="300" @returnMessage="returnMessage"/>
    </div>
  </div>
  <ModalSubscribePlans 
    @showModalSubscribePlans="showModalSubscribePlans"
    :showSubscribe="showSubscribe"
    v-if="storePlan.plans"
    :plans="storePlan.plans"
    :translate="translateModels"
  />
</template>

<style scoped lang="css">
  .form-group input {
    padding: 15px 20px;
    border-radius: 5px;
    margin-bottom: 15px;
    background-color: #fff;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    height: 52px;
  }

  .form-group input::placeholder {
    color: #dedede;
  }

  .form-control:focus {
    color: #000;
    background-color: #f8f8f8;
  }

  .form-group i {
    position: absolute;
    top: 20%;
    right: 0;
    margin-right: 15px;
    font-size: x-large;
    cursor: pointer;
  }

  .select-box {
    padding-left: 22px;
    font-size: small;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 15px;
  }

  .select-box {
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 50%;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" fill="rgb(178,0,0)"/></svg>');
  }

  .plan-button {
    width: 268px;
    height: 35px;
    background-color: #050505 !important;
    border-radius: 15px !important;
    font-family: 'Exo-2';
    font-weight: 700;
    font-size: 16px;
    line-height: 19.2px;
    color: #ffffff;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .plan-button-login {
    width: 268px;
    height: 35px;
    background-color: #050505 !important;
    border-radius: 15px !important;
    font-family: 'Exo-2';
    font-weight: 700;
    font-size: 16px;
    line-height: 19.2px;
    color: #ffffff;
  }

  .resume-title {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #4b4b4b;
  }

  .resume-line {
    border: 1px solid #dedede;
  }

  .resume-plan {
    padding: 30px 0px;
  }

  .resume {
    padding-left: 50px;
  }

  .text-login {
    text-align: center;
    font-family: 'Exo-2';
    font-size: 14px;
    line-height: 21px;
    color: #707070;
    padding-bottom: 10px;
  }

  .p-left {
    padding-left: 75px;
  }  

  /* regras mobile 769px */
  @media screen and (max-width: 769px) {

    .p-left {
      padding-left: 0px;      
      display: block;
    }
    
    .plan-button {
      margin-bottom: 20px;
    }

    .resume {
      margin-top: 30px;
      padding-left: 8px;
    }

    .form-fields {
      border: 1px solid #d9d9d9;
      background-color: #f5f5f5;
      padding: 7px;
      border-radius: 10px;
    }
  }
</style>
